/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useMemo} from 'react';
import {AccountLink, Link} from '@ion/core/src/types/entities';

/**
 * Custom hook for retrieving the current user's account id.
 */
export const useSanitizeAccount = (account: AccountLink): Link => {
  const sanitizedAccount: Link = useMemo(() => {
    const accountLink: AccountLink = {...account};
    delete accountLink?.subAccounts;
    return accountLink as Link;
  }, [account]);
  return sanitizedAccount;
};

export default useSanitizeAccount;
